/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { removeFiltersByKey } from 'store/Filters/actions';
import { useDispatch, useSelector } from 'react-redux';
import { selectTags } from 'store/Tags/selectors';
import { newGetVulns } from 'store/Manage/filterActions';
import { getData } from 'store/Host/actions';
import { eq, createFilter } from 'store/Filters/constants';
import { SEARCH_BY_ENTITIES } from 'store/Filters/entitiesConstants';
import get from 'lodash/get';
import { isFilteringBy } from 'store/Filters/selectors';
import { selectLocation } from 'store/Router/selectors';
import defaultFilters from './defaultFilters';
import {
  Subtitle, Title, Flex, Clear, ExpandedIcon, CollapsedIcon, Content, TextEmptyTags
} from '../styled';
import { SeverityFilter, CheckBoxFilter, TagFilter } from './filterTypes';

const QuickFilters = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const location = useSelector(selectLocation);
  const currentLocationEntity = SEARCH_BY_ENTITIES.find((e) => location.pathname.includes(e.pathname));
  const entityName = get(currentLocationEntity, 'name.value', 'vulns');
  const toggleExpanded = () => setIsExpanded(!isExpanded);
  const tags = useSelector(selectTags);
  const tagObj = {
    title: 'Tags',
    options: tags.map((tag) => tag.name),
    name: 'tags__name',
    type: 'tags',
    displayOptions: tags,
    filter: (filter) => (createFilter('tags__name', eq.name.value, filter)),
    showClear: true
  };

  const noTagsText = 'No Tags Found';

  return (
    <>
      <Subtitle>Quick Filters</Subtitle>
      {defaultFilters[entityName].map((filter) => <QuickFilterItem { ...filter } key={ JSON.stringify(filter) } entityName={ entityName } showClear={ filter.showClear } />)}
      {entityName === 'vulns'
        ? tags.length > 0
          ? <QuickFilterItem { ...tagObj } entityName={ entityName } showClear={ tagObj.showClear } />
          : (
            <>
              <Flex>
                <Title>{tagObj.title}</Title>
                <Clear>Clear</Clear>
                { isExpanded ? <ExpandedIcon onClick={ toggleExpanded } /> : <CollapsedIcon onClick={ toggleExpanded } /> }
              </Flex>
              <Content isExpanded={ isExpanded }><TextEmptyTags>{noTagsText}</TextEmptyTags></Content>
            </>
            )
        : null}

    </>
  );
};

const QuickFilterItem = ({
  title, options, type, filter, name, displayOptions, entityName, showClear
}) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [isExpanded, setIsExpanded] = useState(true);

  const anyFilterApplied = options.some((option) => (isFilteringBy(state, entityName, filter(option))));

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  const handleClick = () => {
    if (showClear && anyFilterApplied) {
      dispatch(removeFiltersByKey(entityName, name));
      if (entityName === 'vulns') dispatch(newGetVulns());
      if (entityName === 'assets') dispatch(getData());
    }
  };

  return (
    <>
      <Flex>
        <Title>{title}</Title>
        <Clear onClick={ handleClick }>Clear</Clear>
        { isExpanded ? <ExpandedIcon onClick={ toggleExpanded } /> : <CollapsedIcon onClick={ toggleExpanded } /> }
      </Flex>

      <Content vertical={ type === 'checkbox' } isExpanded={ isExpanded }>
        {type === 'severity' && (displayOptions.map((option, i) => <SeverityFilter key={ `severity_${option}` } entityName={ entityName } option={ option } filter={ filter(options[i]) } />))}
        {type === 'checkbox' && displayOptions.map((option, i) => <CheckBoxFilter key={ `checkboux_${option}` } entityName={ entityName } option={ option } filter={ filter(options[i]) } />)}
        {type === 'tags' && displayOptions.map((option, i) => <TagFilter key={ `tags_${options[i]}` } entityName={ entityName } name={ options[i] } filter={ filter(options[i]) } />)}
      </Content>
    </>
  );
};

export default QuickFilters;
